import { AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { MyrAPIService } from '../../../api/myr/myrAPI';
import { IReduxRootState } from '../../../app/reduxRootState.interface';
import { ErrorResolution } from '../../../app/common/errorResolution/errorResolution';
import { ErrorResolutionActions } from '../../../app/common/errorResolution/errorResolutionActions';
import { NotificationsActions } from '../../../app/common/notifications/notificationsActions';
import { NotificationAction } from '../../../app/common/notifications/notificationsActionType';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import AccountSecurityActions from '../accountSecurityActions';
import { UpdateEmailAction, UpdateEmailActionType } from './updateEmailActionType';
import { IUpdateEmailRequest } from './updateEmailRequest';
import { MyrAPIEndpoints } from '../../../api/myr/myrAPIEndpoints.constant';

export class UpdateEmailActions {
    public static updateMemberEmail(
        data: IUpdateEmailRequest,
    ): ThunkAction<void, IReduxRootState, {}, AnyAction> {
        return (dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>) => {
            dispatch(request());

            return MyrAPIService.sendRequest(MyrAPIEndpoints.EMAIL, 'PUT', data)
                .then((response: any) => success(dispatch, response.email))
                .catch((errorResolution) => failure(dispatch, errorResolution));
        };

        function request(): UpdateEmailAction {
            return {
                payload: {},
                type: UpdateEmailActionType.UPDATE_EMAIL_REQUEST,
            };
        }

        function success(dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>, email: string) {
            dispatch({
                payload: { email },
                type: UpdateEmailActionType.UPDATE_EMAIL_SUCCESS,
            });
            dispatch(
                NotificationsActions.showSuccess(
                    TranslationHelpers.getFormattedMessage(
                        'notifications.account.email.update.success',
                    ),
                ),
            );
            dispatch(AccountSecurityActions.closeAccountSecurityOverlay());
            window.location.reload();
        }

        function failure(
            dispatch: ThunkDispatch<IReduxRootState, {}, UpdateEmailAction | NotificationAction>,
            errorResolution: ErrorResolution,
        ) {
            dispatch({
                payload: { errorResolution },
                type: UpdateEmailActionType.UPDATE_EMAIL_FAILURE,
            });
            dispatch(
                ErrorResolutionActions.processErrorResolution(
                    errorResolution,
                    'notifications.account.email.update.failure',
                    { challengerPid: data.challengeData.cpid },
                ),
            );
        }
    }
}
